import { ReconRunPayload, ReconRunResponse, SelectOption } from "../../../Types/Reconautomation2.types";
import axiosInstance from "../../../Utils/axiosInstance";

import { fetchReconPhysicalCodes } from "../ContractMap/contractmap.api";

const BASE_URL = "/paper-app/recon-automation-bilat/";

const toBackendDate = (date: string): string => {
  if (!date) return date;
  const [y, m, d] = date.split("-");
  return `${d}-${m}-${y}`;
};

export const fetchContractOptions = async (): Promise<SelectOption[]> => {
  const data = await fetchReconPhysicalCodes();
  return data.map((item) => ({
    label: item.physical_code,
    value: item.id,
  }));
};

export const runReconciliation = async (
  payload: ReconRunPayload
): Promise<ReconRunResponse> => {
  const formData = new FormData();
  formData.append("source", payload.source);
  formData.append("start_date", toBackendDate(payload.start_date));
  formData.append("end_date", toBackendDate(payload.end_date));
  formData.append("file", payload.file);
  if(payload.contract) formData.append("contract", payload.contract);
  if(payload.buy_sell) formData.append("buy_sell", payload.buy_sell);

  const response = await axiosInstance.post<ReconRunResponse>(
    BASE_URL,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data;
};


export { fetchBrokerOptions } from "../../Trading/PaperTrading/FecthApis";